import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { get } from 'lodash';

// Decorators
import { withWindow } from '../../decorators/window';
import Pictogram from './pictogram';
import TranslatedCopy from '../../intl/translated-copy';
import HeaderMenuBook from './header-menu-book';
import HeaderSubmenuCKN from './header-submenu-ckn';
import HeaderMenuQuickbooker from './header-menu-quickbooker';
import ModalPaises from './modal-paises';
import ModalLogin from './modal-login';
import ModalCorporateFlow from '../corporate-modals/Modal-Corporate-Flow';
import ModalChangeCompany from '../corporate-modals/Modal-Corporate-Change-Company';
import ModalProfileSwitchAlertCorporative from '../corporate-modals/ModalProfile-Switch-Alert-Corporative';
import MenuResponsive from '../profile/menu-responsive';
import ModalProfileOffline from '../profile/profile-offline';
import ModalUpdateConsent from '../profile/modal-update-consent';
import { getCMSUrl, getCMSUrlToHome } from '../../constants/cms-urls';
import {
  deleteCookie,
  getCookie,
  isJsonObject,
  openUrlInNewWindow,
  retriveActualHostUrl,
  setTabIndex,
} from '../../utilities/helpers';
import { logoutSessionAction, getControlPanel } from '../../../redux/actions/index';
import { metricaUserLoginAttemp, metricaUserLogOut } from '../../../../src/scripts/utilities/metricas-login';
import HeaderMenuPromotions from './header-menu-promotions';
// Components
import { getErrorMessage } from '../../../redux/actions/index';
import quantityAdultCreator from '../../../redux/actions/quantity-adults-creators';
import quantityInfantCreator from '../../../redux/actions/quantity-infants-creators';
import quantityKidCreator from '../../../redux/actions/quantity-kids-creators';
import Popup from './popup';
import PersistentLogin from './persistent-login';
import { chageTouchPointTypeCp } from '../../../redux/actions/change-touch-point-type-cp-creator';
import HeaderMenuMyTripsPnrLookUpLight from './header-menu-my-trips-pnrLookUpLight';
import HeaderMenuMyTripsBenefits from './header-menu-my-trips-benefits';
import { setOpenModalLogin } from '../../../redux/actions/openModalLogin';
import { setOpenModalSignUp } from '../../../redux/actions/openModalSignUp';

const mapStateToProps = state => ({
  activeBannerUpdateConsent: state.ActiveBannerUpdateConsent,
  codeInicativeAccount: state.UserProfileSession.codeInicativeAccount,
  isActivePersistentLoginPopup: state.UserProfileSession.isActivePersistentLoginPopup,
  isInvalidSession: state.UserProfileSession.isInvalidSession,
  errorMessageCms: state.ErrorMessage.errorMessageCms,
  // Menu promotions e info
  ancillaryOfferCollectionModel: state.Manage.ancillaryOfferCollectionModel,
  changeCorporateCompany: state.Corporate.changeCorporateCompany,
  changeCorporateFlow: state.Corporate.changeCorporateFlow,
  isSignIn: state.UserProfileSession.isSignIn,
  isRetrieveCorporate: state.Corporate.isRetrieveCorporateSession,
  isValidSession: state.UserProfileSession.isValidSession,
  userProfile: state.UserProfileSession.userProfile,
  // Menu promotions e info
  menuPromotions: state.MenuPromotions.menuPromotions,
  panel: state.Manage.controlPanel,
  quantityAdults: state.reducerQuantityAdults.quantityAdults,
  quantityInfants: state.reducerQuantityInfants.quantityInfants,
  quantityKids: state.reducerQuantityKids.quantityKids,
  showModalCorporate: state.Corporate.showModalCorporate,
  storeFronts: state.StoreFront.storeFronts,
  travelInformation: state.TravelInformation.travelInformation,
  userFirstName: state.UserProfileSession.userFirstName,
  userInitials: state.UserProfileSession.userInitials,
  userProfLogout: state.UserProfileSession.userProfLogout,
  userToken: state.UserProfileSession.userToken,
});

/* se añadio el codeInicativeAccount al estago global en este archivo para poder trabajar con el al identificar
  la respuesta de api cuando no existe bd por singin */
class HeaderMain extends PureComponent {
  static defaultProps = {
    storefrontData: {
      activePnrLookUpLight: false,
    },
  }

  constructor() {
    super();
    this.state = {
      activeAdditionalOption: false,
      activeFlightStatus: false,
      activeManageBooking: false,
      codeDBDown: false,
      desiredOffset: 0,
      flightType: '',
      loginEnUs: true,
      loginEsMX: true,
      loginWorld: true,
      openLanguage: false,
      openLoginModal: false,
      openUpdateConsentModal: false,
      px: 0,
      scrollPos: 0,
      showHamburger: false,
      showMenuBook: false,
      showMenuChecking: false,
      showMenuMyTrip: false,
      showProfileMenu: false,
      showPromotionsMenu: false,
      showTravelInfoMenu: false,
      timerID: 0,
      userLogout: false,
    };
    this.cookieExpires = null;

    this.findContainerPayment = this.findContainerPayment.bind(this);
    this.scrollToPay = this.scrollToPay.bind(this);
    this._scroll = this._scroll.bind(this);
    this.handleCloseModalProfOffline = this.handleCloseModalProfOffline.bind(this);
    this.handleShowMenuProfile = this.handleShowMenuProfile.bind(this);
    this.validatorCode = false;
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.openCorporateModals = this.openCorporateModals.bind(this);
    this.onCloseModals = this.onCloseModals.bind(this);
  }

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidMount = () => {
    const { dispatch } = this.props;
    const isLoadingControlPanel = Boolean(this.props?.panel?.loadingControlPanel);
    const isSuccessControlPanel = Boolean(this.props?.panel?.success);
    if (!isLoadingControlPanel && !isSuccessControlPanel) {
      dispatch(getControlPanel());
    }
    if (localStorage.getItem('isLoginForm')) {
      localStorage.removeItem('isLoginForm');
    }
    if (localStorage.getItem('logoutFail')) {
      localStorage.removeItem('logoutFail');
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      activeBannerUpdateConsent,
      isSignIn,
    } = this.props;

    if (isSignIn && typeof nextProps.isSignIn === 'undefined') {
      localStorage.removeItem('initials');
      localStorage.removeItem('firstName');
    }

    if (typeof nextProps.codeInicativeAccount !== null && typeof nextProps.codeInicativeAccount !== undefined && (nextProps.codeInicativeAccount === '15110101' || nextProps.codeInicativeAccount === '15110701')) {
      this.validatorCode = true;

      this.setState({
        codeDBDown: true,
      });
    }

    const isUpdateCosent = get(nextProps.userProfile, 'consents._collection', false);

    if (isSignIn !== nextProps.isSignIn && nextProps.isSignIn && isUpdateCosent) {
      if (isUpdateCosent.some(item => item.status === 'N')) {
        this.setState({ openUpdateConsentModal: true });
      }
    }

    if (activeBannerUpdateConsent !== nextProps.activeBannerUpdateConsent && !nextProps.activeBannerUpdateConsent.isSuccess) {
      this.onSignOut();
    }

    /* Al recibir el cambio este se valida y se actualiza en una variable de estado local para evitar que se muestre en cualquier otro caso si no es este
      codigo de error: 15110101
    if ( nextProps.codeInicativeAccount && nextProps.codeInicativeAccount === '500601' ) {
      this.setState({
        codeDBDown: nextProps.codeInicativeAccount,
      });
    } */
  }

  componentWillUpdate() {
    const { userToken, dispatch, language, country } = this.props;
    const userSession = getCookie('userSession') ? getCookie('userSession') : '';
    let userTokenCookie = null;

    const pos = {
      'store': country,
      'pos': 'WEB',
      'language': language,
    };

    if (userSession && isJsonObject(userSession)) {
      userTokenCookie = JSON.parse(userSession)?.userToken;
    }


    if (!this.cookieExpires && (userToken || userTokenCookie)) {
      const token = (userToken) ? userToken : userTokenCookie;
      this.cookieExpires = true;
      setTimeout(() => {
        this.cookieExpires = null;

        this.setState({
          userLogout: false,
          openLoginModal: false,
        });
        dispatch(logoutSessionAction(token, pos));
      }, 1800000);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  render() {
    const {
      activeCompany,
      ancillaryOfferCollectionModel,
      breakpointNewDesign,
      changeCorporateCompany,
      changeCorporateFlow,
      country,
      dispatch,
      hideMenuList,
      isActiveFlowCorporate,
      isSignIn,
      language,
      mttParam,
      pnrInfo,
      showModalCorporate,
      storefront,
      storeFronts,
      trackLoginUsername,
      userCorporate,
      userToken,
    } = this.props;
    const {
      codeDBDown,
      loginEnUs,
      loginEsMX,
      loginWorld,
      openLoginModal,
      openUpdateConsentModal,
    } = this.state;

    const stData = storeFronts?.find(sf => sf.storefront.identifier === storefront);
    const validateActiveCompanySelected = activeCompany !== null ? true : false;
    const isCorporateSfCMS = stData?.storefront?.isActiveCorporate === 'true';
    const isCorpoprate = isSignIn && userCorporate?.isValidUser && showModalCorporate && !validateActiveCompanySelected && isCorporateSfCMS;

    const headerInner = cx({
      'Header-inner': true,
    });

    if (mttParam && (breakpointNewDesign === 'small' || breakpointNewDesign === 'medium')) {
      return null;
    }

    return (
      <div className={ headerInner }>
        { this.renderLogo() }
        { !hideMenuList && this.renderNavList() }
        { !hideMenuList && this.renderNavRight() }
        { /* modal de plan de contingencia original, sin modificar para que funcione sin ser alterado el comportamiento original */ }
        {
          !loginEnUs || !loginEsMX || !loginWorld ?
            <ModalProfileOffline closeModal={ this.handleCloseModalProfOffline } /> : null
        }
        { !isSignIn && openLoginModal &&
          <ModalLogin openLoginModal={ openLoginModal } onCloseLoginModal={ this.onCloseLoginModal }
            trackLoginUsername={ trackLoginUsername } />
        }
        { /* validar que el modal no se abra si existe una empresa activa en el redux */ }
        { isCorpoprate &&
          <ModalCorporateFlow openCorporateModal={ this.openCorporateModal } />
        }
        { changeCorporateFlow && isCorporateSfCMS &&
          <ModalProfileSwitchAlertCorporative
            ancillaryOfferCollectionModel={ ancillaryOfferCollectionModel }
            country={ country }
            dispatch={ dispatch }
            isActiveFlowCorporate={ isActiveFlowCorporate }
            language={ language }
            onCloseModals={ this.onCloseModals }
            openCorporateModals={ this.openCorporateModals }
            pnrModel={ pnrInfo }
            userToken={ userToken }
          />
        }
        { changeCorporateCompany && isCorporateSfCMS &&
          <ModalChangeCompany
            openCorporateModals={ this.openCorporateModals }
            openCorporateModal={ this.openCorporateModal } />
        }
        { /* modal de plan de contingencia para cuando responde api que no hay bd */ }
        {
          /* ( codeDBDown && typeof codeDBDown !== '' && codeDBDown === '15110101') */
          (this.validatorCode === true && codeDBDown === true) ?
            <ModalProfileOffline closeModal={ this.handleCloseModalProfOffline } /> : null
        }
        { isSignIn && openUpdateConsentModal &&
          <ModalUpdateConsent
            closeModal={ this.onCloseUpdateConsentModal }
            dispatch={ dispatch }
            onSignOut={ this.onSignOut }
          />
        }
      </div>
    );
  }

  renderLogo() {
    const {
      breakpointNewDesign,
      isActiveFlowCorporate,
      showInformation,
      storefront,
      storeFronts,
    } = this.props;

    const isExpanded = breakpointNewDesign === 'medium-high' || breakpointNewDesign === 'large';
    const condensedLogoID = 'logoCondensedAMV2';
    const expandedLogoID = 'logoExpandedAMV2';
    const logoID = isExpanded ? expandedLogoID : condensedLogoID;
    const storeFrontData = storeFronts?.find(sf => sf.storefront.identifier === storefront);
    const logos = storeFrontData?.storefront?.icons;
    const logoSrc = logos && isExpanded && isActiveFlowCorporate ? logos?.corporate : logos?.responsive;
    const skyteamLogoID = 'logoSkyteam';
    const amLogoClasses = cx({
      'Header-logoIconSVG': true,
      'Header-logoIconSVG--AM': !isActiveFlowCorporate,
      'Header-logoIconSVG--AMcondensed': !isExpanded,
      'Header-logoIconSVG--AM--Corporate': isActiveFlowCorporate,
    });

    return (
      <nav>
        <div>
          <div className='Header-logo'>
            { showInformation ?
              <div
                className='Header-logoIcon Header-logoIcon--AM logo-travel'
                title='Aeromexico Home'
                onClick={ () => this.backToAMHome() }>
                <Pictogram
                  className={ amLogoClasses }
                  id={ condensedLogoID } />
              </div> :
              <div
                className='Header-logoIcon Header-logoIcon--AM'
                title='Aeromexico Home'
                onClick={ () => this.backToAMHome() }>
                { isActiveFlowCorporate ?
                  <div className='Header-logoIcon-Corporate-container'>
                    <img
                      className={ amLogoClasses }
                      src={ logoSrc } />
                  </div>
                  :
                  <Pictogram
                    className={ amLogoClasses }
                    id={ logoID } />
                }
                { isExpanded && !isActiveFlowCorporate &&
                  <Pictogram
                    className='Header-logoIconSVG Header-logoIconSVG--skyteam'
                    id={ skyteamLogoID } /> }
              </div>
            }
          </div>
        </div>
      </nav>
    );
  }

  handleClickOutside = (event) => {
    // Esta funcion se va a ocupar cuando ya esten los submenus
    const { dispatch } = this.props;
    const {
      showMenuBook,
      showMenuChecking,
      showMenuMyTrip,
      showProfileMenu,
      showPromotionsMenu,
      showTravelInfoMenu,
    } = this.state;

    if ((showMenuBook && this.BookingMenuNode && !this.BookingMenuNode.contains(event.target) && event.target.className !== 'AirportAutocompleteListItem AirportAutocompleteListItem--search' && event.target.className !== 'AirportAutocompleteListItem-textFound') ||
      (showMenuChecking && this.CheckinMenuNode && !this.CheckinMenuNode.contains(event.target)) ||
      (showMenuMyTrip && this.MyTripMenuNode && !this.MyTripMenuNode.contains(event.target)) ||
      (showPromotionsMenu && this.PromotionsMenuNode && !this.PromotionsMenuNode.contains(event.target)) ||
      (showTravelInfoMenu && this.TravelInfoMenuNode && !this.TravelInfoMenuNode.contains(event.target)) ||
      (showProfileMenu && this.ProfileMenuNode && !this.ProfileMenuNode.contains(event.target))) {
      this.setState({
        showMenuBook: false,
        showMenuChecking: false,
        showMenuMyTrip: false,
        showProfileMenu: false,
        showPromotionsMenu: false,
        showTravelInfoMenu: false,
      });
    }

    if (showMenuBook === false) {
      dispatch(quantityAdultCreator('REMOVE_QUANTITY_ADULT', 1));
      dispatch(quantityInfantCreator('REMOVE_QUANTITY_INFANT', 0));
      dispatch(quantityKidCreator('REMOVE_QUANTITY_KID', 0));
    }
  }

  renderNavList() {
    const {
      breakpointNewDesign,
      cityDestini,
      cityArrival,
      country,
      currentPath,
      dispatch,
      language,
      staticLinks,
      storefront,
      storefrontData,
      storefrontData: {
        activePnrLookUpLight,
      },
      isActiveFlowCorporate,
      isSignIn,
      refunds,
      showInformation,
      orientation,
    } = this.props;
    const {
      showMenuBook,
      showMenuChecking,
      showMenuMyTrip,
      activeManageBooking,
      activeFlightStatus,
      activeAdditionalOption,
    } = this.state;

    const switchNewLook = activePnrLookUpLight;
    const notRefundsAndInformationNotNull = breakpointNewDesign !== 'small' && (!showInformation || showInformation === null) && !refunds;

    const checkinMenuClasses = cx({
      'is-active': showMenuChecking,
    });

    const myTripMenuClasses = cx({
      'is-active': showMenuMyTrip,
    });

    const bookMenuClasses = cx({
      'is-active': true,
    });

    const bookNavListItemClasses = cx({
      'Header-navListLink': true,
      'Header-navListLink--main': true,
      'Header-navListLink--active Header-navListLink--Hover': showMenuBook,
      'Header-navListLink--dropdown': true,
    });

    const bookNavListCknClasses = cx({
      'Header-navListLink': true,
      'Header-navListLink--main': true,
      'Header-navListLink--Hover-blue': isSignIn,
      'Header-navListLink--active Header-navListLink--Hover': showMenuChecking,
    });

    const bookNavListMtpClasses = cx({
      'Header-navListLink': true,
      'Header-navListLink--main': true,
      'Header-navListLink--Hover-blue': isSignIn,
      'Header-navListLink--active Header-navListLink--Hover': showMenuMyTrip,
    });

    const exchangeApi = localStorage.getItem('exchangeApi');
    const DateIni = localStorage.getItem('DateIni');
    const DateFini = localStorage.getItem('DateFini');
    const paxType = localStorage.getItem('paxType');
    const longEx = localStorage.getItem('Longitud');

    return (
      <nav className='Header-navListWrapper'>
        { notRefundsAndInformationNotNull ?
          <ul className='Header-navList'>
            <li ref={ (ref) => this.BookingMenuNode = ref }>
              <div
                id='menu-button-bkn'
                className={ bookNavListItemClasses }
                onClick={ (e) => this.trackMenuClick('Booking', 'BKN', e) }
                role='button'
                tabIndex={ 0 }>
                <HeaderMenuBook
                  className={ bookMenuClasses }
                  currentPath={ currentPath }
                  renderSubMenuButton={ this.renderSubMenuButton }
                  staticLinks={ staticLinks }
                  storefront={ storefront } />
                <TranslatedCopy
                  copyID='APP_BOOK'
                  id='menu-label-bkn'
                  className='ActiveNavListLink'
                />
                { showMenuBook ?
                  <HeaderMenuQuickbooker
                    dispatch={ dispatch }
                    isActiveFlowCorporate={ isActiveFlowCorporate }
                    storefront={ storefront }
                    country={ country }
                    language={ language }
                  />
                  : null
                }
              </div>
            </li>
            {
              switchNewLook ?
                null
                : <li>
                  <a
                    href={ getCMSUrl(country, language, 'MANAGE_YOUR_BOOKING') }
                    className={ `Header-navListLink Header-navListLink--main ${activeManageBooking ? 'Header-navListLink--active' : ''}` }
                    onClick={ (e) => this.trackMenuClick('Manage', 'MYB', e) }
                    id='manage-booking'
                    tabIndex={ 1 } >
                    <TranslatedCopy
                      id='manage-booking-label'
                      copyID='APP_MY_TRIPS'
                      className='ActiveNavListLink' />
                  </a>
                </li>
            }
            {
              switchNewLook ?
                <li ref={ (ref) => this.MyTripMenuNode = ref } >
                  <div
                    id='menu-button-myb'
                    className={ bookNavListMtpClasses }
                    onClick={ (e) => this.trackMenuClick('My trips', 'MTP', e) }
                    tabIndex={ 2 }
                  >
                    <span className='ActiveNavListLink'>
                      <i
                        className='Icon Icon--suitcase Icon-MyTrips'
                        id='menu-button-myb' />
                      <TranslatedCopy
                        id='menu-label-myb'
                        copyID='HUB_MYTRIP_HEADER'
                      />
                    </span>
                    { showMenuMyTrip ?
                      <div className={ `PnrLookUpContainer ${myTripMenuClasses}` }>
                        <HeaderMenuMyTripsBenefits />
                        <HeaderMenuMyTripsPnrLookUpLight
                          country={ country }
                          isSignedIn={ isSignIn }
                          language={ language }
                          // userToken= { userToken }
                          openModalLogin={ this.openModalLogin } />
                      </div>
                      : null
                    }
                  </div>
                </li>
                :
                <li ref={ (ref) => this.CheckinMenuNode = ref } >
                  <div
                    id='menu-button-checkin'
                    className={ bookNavListCknClasses }
                    onClick={ (e) => this.trackMenuClick('Check-In', 'CKN', e) }
                    tabIndex={ 2 }
                  >
                    <TranslatedCopy
                      id='menu-label-checkin'
                      copyID='APP_CHECK_IN'
                      className='ActiveNavListLink'
                    />
                    { showMenuChecking ?
                      <div>
                        { <HeaderSubmenuCKN
                          className={ checkinMenuClasses }
                          isSignedIn={ isSignIn }
                          title='APP_ADMIN_CHECK_IN'
                          // userToken= { userToken }
                          bookMenuType={ undefined }
                          menuBookStyle={ orientation === 'portrait' ? { height: innerHeight } : {} }
                          openModalLogin={ this.openModalLogin }
                        /> }
                      </div>
                      : null
                    }
                  </div>
                </li>
            }
            { storefrontData && storefrontData.staticLinks && storefrontData.staticLinks.headerFlightStatus && storefrontData.staticLinks.headerFlightStatusUrl && storefrontData.staticLinks.headerFlightStatus.length > 0 ?
              <li>
                <a
                  href={ getCMSUrlToHome(country, language, storefrontData.staticLinks.headerFlightStatusUrl) }
                  className={ `Header-navListLink Header-navListLink--main ${activeFlightStatus ? 'Header-navListLink--active' : ''}` }
                  id='fligh-status'
                  onClick={ (e) => this.trackMenuClick('FlightStatus', 'FS', e) } >
                  <span id='fligh-status-label' className='ActiveNavListLink' >{ storefrontData.staticLinks.headerFlightStatus }</span>
                </a>
              </li> : null
            }
            { storefrontData && storefrontData.staticLinks && storefrontData.staticLinks.headerAdditionalOption && storefrontData.staticLinks.headerAdditionalOptionUrl && storefrontData.staticLinks.headerAdditionalOption.length > 0 ?
              <li>
                <a
                  href={ getCMSUrlToHome(country, language, storefrontData.staticLinks.headerAdditionalOptionUrl) }
                  className={ `Header-navListLink Header-navListLink--main ${activeAdditionalOption ? 'Header-navListLink--active' : ''}` }
                  id='additional-option'
                  onClick={ (e) => this.trackMenuClick('AdditionalOption', 'AO', e) } >
                  <span id='additional-option-label' className='ActiveNavListLink' >{ storefrontData.staticLinks.headerAdditionalOption }</span>
                </a>
              </li> : null
            }
          </ul>
          :
          <>
            { refunds &&
              <ul className='Header-navList Header-booking'>
                <li>
                  <TranslatedCopy copyID='APP_REFUND' />
                </li>
              </ul>
            }
          </>
        }
        { showInformation && breakpointNewDesign !== 'small' &&
          <div className='Header-bookingRoute'>
            <ul className='Header-navList Header-booking Header-border'>
              <li className='Header-bookingDates'>
                <span className='Header-bookingDates-destini'>
                  { cityDestini }
                </span>
                <span className='Header-bookingIcon Icon Icon--arrowSingleTrip'></span>
                { cityArrival }
              </li>
              { exchangeApi === 'ROUND_TRIP' ?
                <li className='Header-bookingDates'> { DateIni }
                  <span className='Header-bookingDates-Before'>{ DateFini }</span>
                </li> :
                <li className='Header-bookingDates'> { DateFini } </li>
              }
              { exchangeApi === 'ONE_WAY' ?
                <li className='Header-bookingDates'>Sencillo</li> :
                null
              }
              { exchangeApi === 'ROUND_TRIP' ?
                <li className='Header-bookingDates'>Ida y vuelta</li> :
                null
              }
              { longEx >= 2 ?
                <li className='Header-bookingDates'>
                  { longEx } Viajeros </li> :
                paxType === 'ADT' ?
                  <li className='Header-bookingDates'>Adulto</li> :
                  paxType === 'CHD' ?
                    <li className='Header-bookingDates'>Niño</li> :
                    paxType === 'INF' ?
                      <li className='Header-bookingDates'>Infante</li> :
                      null
              }
            </ul>
          </div>
        }

      </nav>
    );
  }


  renderNavRight() {
    const {
      bookMenuType,
      breakpoint,
      breakpointNewDesign,
      dispatch,
      isActiveFlowCorporate,
      isActivePersistentLoginPopup,
      isSignIn,
      language,
      menuPromotions,
      storefront,
      travelInformation,
      userInitials,
      userLogout,
    } = this.props;

    const {
      hasAdvisoryRequestedClose,
    } = this.state;

    const { openLanguage, showPromotionsMenu, showTravelInfoMenu } = this.state;

    const navRightClasses = cx({
      'Header-navRight': true,
    });

    const init = localStorage.getItem('initials');

    const promotionsListItemClasses = cx({
      'Header-navListLink': true,
      'Header-navListLink--sub': true,
      'Header-navListLink--active': showPromotionsMenu,
    });

    const travelInfoMenuClasses = cx({
      'is-active': showTravelInfoMenu,
    });
    const travelInfoListItemClasses = cx({
      'Header-navListLink': true,
      'Header-navListLink--sub': true,
      'Header-navListLink--active': showTravelInfoMenu,
    });
    const promotionsMenuClasses = cx({
      // 'is-active': true,
      'is-active': showPromotionsMenu,
      // 'hasTravelAdvisory': hasTravelAdvisory && this._validateIsHome,
      'has-travelAdvisoryRequestedClose': hasAdvisoryRequestedClose && this._validateIsHome,
    });

    return (
      <ul className={ navRightClasses }>
        { breakpointNewDesign === 'large' ?
          <li>
            <ul className='Header-navList'>
              { Object.keys(menuPromotions).length > 0 ?
                <li ref={ (ref) => this.PromotionsMenuNode = ref }>
                  <div
                    id='menu-button-promotion'
                    className={ promotionsListItemClasses }
                    onClick={ (e) => this.trackMenuClick('Promotions', 'PRO', e) }
                    onMouseOut={ this.handleBookMenuCollapse }
                    onTouchEnd={ this.handleBookMenuTap }
                    role='button'
                    tabIndex={ 0 }
                  >
                    <HeaderMenuPromotions
                      bookMenuType={ bookMenuType }
                      className={ promotionsMenuClasses }
                      menuOptions={ menuPromotions }
                      language={ language }
                    />
                    <TranslatedCopy
                      id='menu-label-promotion'
                      copyID='APP_PROMOTIONS'
                      className='ActiveNavListLink'
                      spaceBefore={ true }
                    />
                  </div>
                </li> : null
              }
              { Object.keys(travelInformation).length > 0 ?
                <li ref={ (ref) => this.TravelInfoMenuNode = ref }>
                  <div
                    id='menu-button-travelerInfo'
                    className={ travelInfoListItemClasses }
                    onClick={ (e) => this.trackMenuClick('travelerInfo', 'TRAINFO', e) }
                    role='button'
                    tabIndex={ 0 }
                  >
                    <HeaderMenuPromotions
                      bookMenuType={ bookMenuType }
                      className={ travelInfoMenuClasses }
                      menuOptions={ travelInformation }
                      language={ language }
                    />
                    <span id='menu-label-travelerInfo' className='ActiveNavListLink'>
                      <span id='menu-label-icon-travelerInfo' className='Icon Icon--travel_information_solid'></span>
                      <TranslatedCopy
                        id='menu-label-text-travelerInfo'
                        copyID='APP_FLIGHT_INFORMATION'
                        spaceBefore={ true }
                      />
                    </span>
                  </div>
                </li> : null
              }
            </ul>
          </li> : null }
        { breakpointNewDesign === 'small' ? this.renderCart() : null }
        <li className={ `Header-search-wrapper ${!isSignIn && init ? 'persistentLogIn' : ''}` }>
          { this.renderSearchButton() }
        </li>
        { this.props.showInformation ? null : (!userInitials && !init) ? this.renderOriginalSection() : null }
        {
          openLanguage && (userInitials || init) && breakpoint === 'large' &&
          <ModalPaises openLanguage={ this.openLanguage } />
        }
        { ((breakpointNewDesign === 'large' || breakpointNewDesign === 'medium-high') && (userInitials || init)) ? this.renderProfile() : null }
        {
          (!userInitials && !init) && (breakpointNewDesign === 'large' || breakpointNewDesign === 'medium-high') ?
            <button
              className='Header-profileLogin'
              onClick={ () => { this.handleClickOpenModal('header', true); } }>
              <TranslatedCopy copyID='APP_LOGIN' />
            </button> : null
        }
        { breakpointNewDesign === 'small' || breakpointNewDesign === 'medium' ?
          <MenuResponsive
            breakpointNewDesign={ breakpointNewDesign }
            closeModalLogin={ this.onCloseLoginModal }
            dispatch={ dispatch }
            initials={ userInitials ? userInitials : init }
            isActiveFlowCorporate={ isActiveFlowCorporate }
            isActivePersistentLoginPopup={ isActivePersistentLoginPopup }
            isPersistentLogin={ !isSignIn && init }
            isSignIn={ isSignIn }
            language={ language }
            onSignOut={ this.onSignOut }
            openModalLogin={ this.openModalLogin }
            storefront={ storefront }
            userLogout={ userLogout }
          /> : null }
        { breakpointNewDesign === 'small' || breakpointNewDesign === 'medium' || breakpointNewDesign === 'medium-high' ? this.renderHamburgerTrigger() : null }
      </ul>
    );
  }

  trackMenuClick(option, type, e = null) {
    const { closeHamburger } = this.props;
    const id = e.target.id;
    const idMenuOptions = ['manage-booking-label', 'manage-booking', 'menu-button-myb', 'menu-label-myb', 'menu-button-checkin', 'menu-label-checkin', 'menu-button-bkn', 'menu-label-bkn', 'menu-button-promotion', 'menu-label-promotion', 'menu-button-travelerInfo', 'menu-label-travelerInfo', 'menu-label-text-travelerInfo', 'menu-label-icon-travelerInfo', 'fligh-status', 'fligh-status-label', 'additional-option', 'additional-option-label'];

    if (idMenuOptions.includes(id)) {
      const {
        showMenuBook,
        showMenuChecking,
        showMenuMyTrip,
        showPromotionsMenu,
        showTravelInfoMenu,
        activeManageBooking,
        activeFlightStatus,
        activeAdditionalOption,
      } = this.state;

      this.showHeaderSubmenu(
        type === 'BKN' ? !showMenuBook : false,
        type === 'CKN' ? !showMenuChecking : false,
        type === 'MTP' ? !showMenuMyTrip : false,
        type === 'PRO' ? !showPromotionsMenu : false,
        type === 'TRAINFO' ? !showTravelInfoMenu : false,
        type === 'MYB' ? !activeManageBooking : false,
        type === 'FS' ? !activeFlightStatus : false,
        type === 'AO' ? !activeAdditionalOption : false,
        option,
        type);
    }
    closeHamburger();
  }

  showHeaderSubmenu(showMenuBook, showMenuChecking, showMenuMyTrip, showPromotionsMenu, showTravelInfoMenu, activeManageBooking, activeFlightStatus, activeAdditionalOption) {
    this.setState({
      showMenuBook: showMenuBook,
      showMenuChecking: showMenuChecking,
      showMenuMyTrip: showMenuMyTrip,
      showPromotionsMenu: showPromotionsMenu,
      showTravelInfoMenu: showTravelInfoMenu,
      activeManageBooking: activeManageBooking,
      activeFlightStatus: activeFlightStatus,
      activeAdditionalOption: activeAdditionalOption,
    });
  }

  renderSearchButton() {
    const { isActiveFlowCorporate } = this.props;
    const headerSerachItemClasses = cx({
      'Header-searchItem--corporate': isActiveFlowCorporate,
      'Header-searchItem': !isActiveFlowCorporate,
    });
    return (
      <button
        className={ headerSerachItemClasses }
        onClick={ () => {
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'header_promotions',
              'promotion_name': 'AMAIA Chat Launch',
              'section_click': 'Header - Search',
            });
          }
          this.props.handleOpenSearchModal();
        } }
        type='button'
      >
        <span className='Icon Icon--search'></span>
      </button>
    );
  }

  renderProfile = () => {
    const {
      userCorporate,
    } = this.props;

    const htmlTag = document.getElementsByTagName('html')[0];
    const init = localStorage.getItem('initials');
    const headerProClasse = cx({
      'Header-profile': true,
      'Header-profile--isSignIn': userCorporate.isValidUser,
      'Header-profile--isPersistentLogIn': !userCorporate.isValidUser,
    });

    htmlTag.classList.remove('Modal-open--state');
    if (localStorage.hasOwnProperty('position') && init == null) {
      const position = localStorage.getItem('position');
      window.scrollTo(0, position);
    }

    return (
      <li className={ headerProClasse }>
        { this.renderProfileSignedIn() }
      </li>
    );
  }

  renderProfileSignedIn = () => {
    const {
      breakpointNewDesign,
      dispatch,
      isActiveFlowCorporate,
      isActivePersistentLoginPopup,
      isSignIn,
      pnrInfo,
      userInitials,
      userFirstName,
    } = this.props;
    const { showProfileMenu } = this.state;

    const classes = cx({
      'Header-profileSignedInBtn': true,
      'is-active': showProfileMenu,
    });
    const pnrCorporate = pnrInfo && pnrInfo.isCorporateFlow;
    const init = localStorage.getItem('initials');
    const fName = localStorage.getItem('firstName');
    const isMobile = breakpointNewDesign === 'small';
    const showPopupPersistentLogin = !isSignIn && init && !isMobile && isActivePersistentLoginPopup;

    if (!userInitials && !init) { return null; }
    return (
      <ul className='Header-profileItems'>
        <li
          className='Header-profileSignedIn'
          onClick={ this.handleShowMenuProfile }
          ref={ (ref) => this.ProfileMenuNode = ref }
        >
          <div className={ `Header-userIcon ${showProfileMenu ? 'is-active' : ''} ${isActiveFlowCorporate ? 'is-corporate' : ''}` }>{ (userInitials) ? userInitials : init }</div>
          <button
            className={ classes }
            onKeyDown={ (e) => this.handleProfileKeyDown(e) }
            onTouchEnd={ this.handleProfileTap }>
            <div className='Header-userData-wrapper'>
              <TranslatedCopy
                copyID='PROFILE_HI'
                tagName='span'
                user={ (userFirstName) ? userFirstName : fName }
              />
              { pnrCorporate && isActiveFlowCorporate &&
                <TranslatedCopy
                  className='corporate--account'
                  copyID='PRO_CORPORATE_MODAL'
                  tagName='span' />
              }
            </div>
            <span className='Icon Icon--arrowSmallDown'></span>
          </button>
          { this.renderProfileMenu() }
        </li>
        { showPopupPersistentLogin &&
          <Popup
            className='PersistentLogin-popup'
            hasTravelerAdvisoryBar={ 'hasTravelerAdvisories' }
            isHome={ true }
            position='right' >
            <PersistentLogin
              dispatch={ dispatch }
              openModalLogin={ this.openModalLogin } />
          </Popup> }
      </ul>
    );
  }

  handleShowMenuProfile() {
    const { showProfileMenu } = this.state;
    this.setState({ showProfileMenu: !showProfileMenu });
  }

  openModalLogin = (isClickedOnHeader) => {
    const { panel, isSignIn, dispatch } = this.props;
    const { openLoginModal /* codeDBDown */ } = this.state;
    let valid = true;
    const pathname = window.location.pathname;
    const htmlTag = document.getElementsByTagName('html')[0];
    if (window.scrollY != 0) {
      localStorage.setItem('position', window.scrollY);
    }

    if (isClickedOnHeader) {
      dispatch(setOpenModalLogin('Profile'));
    }

    if (isClickedOnHeader) {
      dispatch(setOpenModalSignUp('Profile'));
    }

    htmlTag.classList.add('Modal-open--state');
    if (panel.nodes) {
      if (panel.nodes[0].node.ctaEnUs == '0') {
        valid = false;
        this.setState({ loginEnUs: false });
      }
      if (panel.nodes[0].node.ctaEsMx == '0') {
        valid = false;
        this.setState({ loginEsMX: false });
      }
      if (panel.nodes[0].node.ctaWorld == '0') {
        valid = false;
        this.setState({ loginWorld: false });
      }
    }

    /* preparandomcondicion para que se muestre modal de profileof cuando se desconeta la base
      o esta no exista como respuesta de api, por lo tanto solo cuando tenga este codigo de error
      se debera de mostrar code: 15110101  */
    if (panel.nodes && this.validatorCode === true) {
      if (panel.nodes[0].node.ctaEnUs == '1') {
        valid = false;
        this.setState({ loginEnUs: false });
      }
      if (panel.nodes[0].node.ctaEsMx == '1') {
        valid = false;
        this.setState({ loginEsMX: false });
      }
      if (panel.nodes[0].node.ctaWorld == '1') {
        valid = false;
        this.setState({ loginWorld: false });
      }
    }
    if (!isSignIn && !openLoginModal && valid) {
      this.setState({ openLoginModal: true });
    }

    // metrica login attempt
    localStorage.setItem('loginButton', 'Header');
    const button = localStorage.getItem('loginButton');
    metricaUserLoginAttemp(dispatch, pathname, button);
  }

  onCloseLoginModal = () => { // (on) 'cause it's a handler dude...
    const { openLoginModal } = this.state;
    const htmlTag = document.getElementsByTagName('html')[0];

    htmlTag.classList.remove('Modal-open--state');
    if (localStorage.hasOwnProperty('position')) {
      const position = localStorage.getItem('position');
      window.scrollTo(0, position);
    }

    if (openLoginModal) {
      this.setState({ openLoginModal: false });
    }
    localStorage.removeItem('loginButton');
  }

  openCorporateModal = () => {
    const {
      panel,
    } = this.props;

    const htmlTag = document.getElementsByTagName('html')[0];
    if (window.scrollY != 0) {
      localStorage.setItem('position', window.scrollY);
    }

    htmlTag.classList.add('Modal-open--state');
    if (panel.nodes) {
      if (panel.nodes[0].node.ctaEnUs == '0') {
        this.setState({ loginEnUs: false });
      }
      if (panel.nodes[0].node.ctaEsMx == '0') {
        this.setState({ loginEsMX: false });
      }
      if (panel.nodes[0].node.ctaWorld == '0') {
        this.setState({ loginWorld: false });
      }
    }

    if (panel.nodes && this.validatorCode === true) {
      if (panel.nodes[0].node.ctaEnUs == '1') {
        this.setState({ loginEnUs: false });
      }
      if (panel.nodes[0].node.ctaEsMx == '1') {
        this.setState({ loginEsMX: false });
      }
      if (panel.nodes[0].node.ctaWorld == '1') {
        this.setState({ loginWorld: false });
      }
    }
  }

  onCloseUpdateConsentModal = () => {
    const { openUpdateConsentModal } = this.state;

    if (openUpdateConsentModal) {
      this.setState({ openUpdateConsentModal: false });
    }
  }

  renderOriginalSection() {
    const { breakpointNewDesign, isSignIn } = this.props;
    const isLargeBreakpoint = breakpointNewDesign === 'large' || breakpointNewDesign === 'medium-high';

    return (
      <li className={ `Header-profile ${isSignIn && 'Header-profile--isSignIn'}` }>
        <ul className='Header-profileItems'>
          { isLargeBreakpoint ? this.renderProfileItems() : null }
        </ul>
      </li>
    );
  }

  renderProfileItems() {
    const { openLanguage } = this.state;
    return (
      <li className='Header-profileWrapper'>
        {
          openLanguage &&
          <ModalPaises openLanguage={ this.openLanguage } />
        }
      </li>
    );
  }

  backToAMHome() {
    const {
      country,
      language,
    } = this.props;
    // DeepLink para Home E4
    window.location = `https://${location.host}/${language}-${country}`;
  }
  // Change to arrow function undefined to avoid errors
  handleBookMenuCollapse = () => {
    this.setState({
      showBookMenu: false,
    });
  }

  renderHamburgerTrigger() {
    const { showHamburger } = this.props;

    const iconClasses = cx({
      'Icon': true,
      'Icon--hamburger': !showHamburger,
      'Icon--xThin': showHamburger,
    });

    const headerHambuguerClasses = cx({
      'Header-hamburger': true,
      'Header-hamburger--open': showHamburger,
    });

    return (
      <li className={ headerHambuguerClasses }>
        <button
          aria-label='Expand Nav'
          className={ iconClasses }
          onClick={ this.handleHamburgerClick }></button>
      </li>
    );
  }

  renderCart() {
    const { pnrInfo, hasUpdateCart } = this.props;
    let isOnHold = false;
    let hasUnpaidAncillary = false;
    let hasUnpaidSeat = false;
    if (pnrInfo && pnrInfo.pnrCode !== undefined && pnrInfo.pnrCode !== '') {
      hasUnpaidAncillary = pnrInfo.hasUnpaidAncillary();
      hasUnpaidSeat = pnrInfo.hasUnpaidSeat();
      isOnHold = pnrInfo.reservationStatus === 'ON_HOLD' ? true : false;
    }
    return (
      <li className='HeaderCart'>
        { isOnHold || hasUpdateCart || hasUnpaidAncillary || hasUnpaidSeat ?
          <i
            id='icon-pay-dsk'
            onClick={ this.scrollToPay }
            className='Icon Icon--cart manage-options-banner__icon-count isMobile'>
            <span className='manage-options-banner__icon-count__count'></span>
          </i>
          : null }
      </li>
    );
  }

  findContainerPayment() {
    const data = document.getElementById('payments-container').getBoundingClientRect();
    return data.top;
  }

  scrollToPay() {
    const topPayment = this.findContainerPayment() - 80 + this._getPageScrollAmt();
    this._scrollToMyb(topPayment, 75);
  }

  _getPageScrollAmt() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }

  _scrollToMyb(offset, px) {
    const fps = 1000 / 60;
    const initOffset = this._getPageScrollAmt();
    const desiredOffset = initOffset + offset;
    const timerID = setInterval(this._scroll, fps);
    this.setState({
      scrollPos: initOffset,
      px: px,
      desiredOffset: desiredOffset,
      timerID: timerID,
    });
  }

  _scroll() {
    const { desiredOffset, px, timerID } = this.state;
    let { scrollPos } = this.state;
    const { stopScrollPayment, initstopScrollPayment } = this.props;
    scrollPos = scrollPos + px;
    this.setState({
      scrollPos: scrollPos,
    });
    if (desiredOffset > scrollPos && !stopScrollPayment) {
      document.body.scrollTop = scrollPos;
      window.scrollTo(0, scrollPos);
    } else {
      if (!stopScrollPayment) {
        document.body.scrollTop = desiredOffset;
        window.scrollTo(0, desiredOffset);
      }
      initstopScrollPayment();
      clearInterval(timerID);
    }
  }

  renderProfileMenu() {
    const classes = cx({
      'HeaderProfileMenu': true,
      'is-active': this.state.showProfileMenu,
    });

    const condensedLogoID = 'logoCondensedAMV2Blue';
    const logoID = condensedLogoID;

    return (
      <div ref='profileMenu' className={ classes }>
        <div className='HeaderProfileMenu-section HeaderProfileMenu-section--title'>
          <TranslatedCopy
            copyID='LGN_MENU_TITLE'
            tagName='span'
          />
        </div>
        <ul className='HeaderProfileMenu-section'>
          <li className=''>
            <i className='Icon Icon--profileNew'></i>
            <a className='HeaderProfileMenu-link'
              onClick={ (e) => this.redirectProfileEFour(e, 1) }>
              <TranslatedCopy copyID='LGN_MENU_PERFIL' />
            </a>
          </li>
          <li className=''>
            <i className='Icon Icon--mytripsNew'></i>
            <a className='HeaderProfileMenu-link'
              onClick={ (e) => this.redirectProfileEFour(e, 0) }>
              <TranslatedCopy copyID='NS_MYB_HEADER' />
            </a>
          </li>
          <li className=''>
            <i className='Icon Icon--walletBitcoin'></i>
            <a className='HeaderProfileMenu-link'
              onClick={ (e) => this.redirectProfileEFour(e, 2) }>
              <TranslatedCopy copyID='USER_PROFILE_MY_PAYMENTS' />
            </a>
          </li>
          <li className=''>
            <Pictogram id={ logoID } />
            <a className='HeaderProfileMenu-link'
              onClick={ (e) => this.redirectProfileEFour(e, 3) }>
              <TranslatedCopy copyID='USER_PROFILE_MY_CLUB_PREMIER' />
            </a>
          </li>
        </ul>
        <div className='HeaderProfileMenu-section Menu-section__logout'>
          <button
            className='HeaderProfileMenu-link HeaderProfileMenu-link--logout Icon Icon--log-out'
            onClick={ this.onSignOut }>
            <TranslatedCopy className='logoutText' copyID='APP_LOGOUT' />
          </button>
        </div>
      </div>
    );
  }

  redirectProfileEFour = (e, tabIndex) => { // Delegate the user validation onClick.
    const {
      isSignIn,
      language,
      storefront,
    } = this.props;

    setTabIndex(tabIndex);

    if (!isSignIn) {
      this.openModalLogin();
    } else {
      e.preventDefault();
      const redirectHost = window.location.host;
      retriveActualHostUrl(redirectHost, language, storefront);
    }
  }

  handleSignUp() {
    const { country, language } = this.props;
    let path = '';

    if (language === 'en' && country === 'us') {
      path = 'https://pages.mx.aeromexico.com/NewsletterRegistration';
    } else if ((language === 'es' && country === 'us') || (language === 'es' && country === 'mx')) {
      path = 'https://pages.mx.aeromexico.com/RegistroNewsletter';
    }

    if (path !== '') {
      openUrlInNewWindow(path, 440, 680);
    }
  }

  onSignOut = () => {
    const { dispatch, userToken, language, country, handlePopUpSing, errorMessageCms, codeInicativeAccount } = this.props;
    let cookieToken = getCookie('userSession');
    const pathname = window.location.pathname;

    this.setState({
      userLogout: false,
      openLoginModal: false,
    });

    const pos = {
      'store': country,
      'pos': 'WEB',
      'language': language,
    };

    if (userToken) {
      dispatch(logoutSessionAction(userToken, pos));
    } else if (cookieToken) {
      if (isJsonObject(cookieToken)) {
        cookieToken = JSON.parse(cookieToken)?.userToken;
        dispatch(logoutSessionAction(cookieToken, pos));
      }
    } else if (!userToken && !cookieToken) {
      localStorage.removeItem('initials');
      localStorage.removeItem('firstName');
      deleteCookie('userSession');
      deleteCookie('userSessionCorporate');
      handlePopUpSing(true);
    }

    localStorage.removeItem('loginButton');
    const errorMessage = errorMessageCms?.errorMessages?.[0]?.errorMessage?.identifier;
    if (errorMessage === '500016') {
      dispatch(getErrorMessage(codeInicativeAccount, language, true));
    }
    // Metrica logOut
    metricaUserLogOut(dispatch, pathname);
  }

  openLanguage = () => {
    const { openLanguage } = this.state;
    this.setState({ openLanguage: !openLanguage });
  }

  handleCloseModalProfOffline = () => {
    this.setState({
      loginEnUs: true,
      loginEsMX: true,
      loginWorld: true,
      codeDBDown: false,
    });

    this.validatorCode = false;
  }

  renderSubMenuButton({
    copy,
    destinationLink = 'https://www.aeromexico.com/',
    icon = '',
    isTargetBlank = false,
    pictogramId = false,
  }) {
    return (
      <li>
        <div className='HeaderMenuBook-item'>
          <a
            className='HeaderMenuBook-link HeaderMenuBook-link--vacation'
            target={ isTargetBlank ? '_blank' : '' }
            rel={ isTargetBlank ? 'noopener noreferrer' : '' }
            href={ destinationLink }>
            <div className='HeaderMenuBook-content'>
              { pictogramId ?
                <Pictogram className='HeaderMenuBook-itemIcon' id={ pictogramId } /> :
                <span className={ `HeaderMenuBook-itemIcon Icon Icon--${icon} HeaderMenuBook-itemIcon--iconFont` } /> }
              <div className='HeaderMenuBook-wrapCopy'>
                <TranslatedCopy
                  className='HeaderMenuBook-itemTitle'
                  copyID={ copy } />
              </div>
            </div>
          </a>
        </div>
      </li>
    );
  }

  handleHamburgerClick = () => {
    const {
      showHamburger,
      openHamburger,
      closeHamburger,
    } = this.props;

    this.setState({
      showProfileMenu: false,
      showMenuBook: false,
      showMenuChecking: false,
      showPromotionsMenu: false,
      showTravelInfoMenu: false,
    });

    if (!showHamburger) {
      openHamburger();
    } else {
      closeHamburger();
    }
  }

  handleClickOpenModal(typeTouchPoint, isClickedOnHeader) {
    const { dispatch } = this.props;
    dispatch(chageTouchPointTypeCp(typeTouchPoint));
    this.openModalLogin(isClickedOnHeader);
  }

  openCorporateModals = () => {
    const {
      panel,
    } = this.props;

    const htmlTag = document.getElementsByTagName('html')[0];
    if (window.scrollY != 0) {
      localStorage.setItem('position', window.scrollY);
    }
    htmlTag.classList.add('Modal-open--state');
    if (panel.nodes) {
      if (panel.nodes[0].node.ctaEnUs == '0') {
        this.setState({ loginEnUs: false });
      }
      if (panel.nodes[0].node.ctaEsMx == '0') {
        this.setState({ loginEsMX: false });
      }
      if (panel.nodes[0].node.ctaWorld == '0') {
        this.setState({ loginWorld: false });
      }
    }
  }

  onCloseModals = () => {
    const htmlTag = document.getElementsByTagName('html')[0];
    htmlTag.classList.remove('Modal-open--state');
    if (localStorage.hasOwnProperty('position')) {
      const position = localStorage.getItem('position');
      window.scrollTo(0, position);
    }
    this.setState({ openProfileCorporateModals: false });
  }
}

HeaderMain = connect(mapStateToProps)(HeaderMain);

export default withWindow(HeaderMain);
